import {configureStore, ThunkAction, Action} from '@reduxjs/toolkit';
import navMenuReducer from './header/header.slice';
import currentUserReducer from './currentUser/currentUser.slice';
import permissionsReducer from './permissions/permissions.slice';

export const store = configureStore({
  reducer: {
    navMenu: navMenuReducer,
    user: currentUserReducer,
    permissions: permissionsReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
